import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var UndoSvg = function UndoSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M2.714 7.149h4.18V8.68H0V1.787h1.532v4.374C3.502 3.305 6.334 0 12 0A12 12 0 1 1 0 12h1.532A10.468 10.468 0 1 0 12 1.532c-4.961 0-7.38 2.837-9.286 5.617"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
export var Undo = function Undo(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: UndoSvg
  }));
};